<template lang="pug">
  #top-page
    b-card(header-tag="header")
      template(v-if="isLoading === true")
        loading(:height="200")
      template(v-else)
        b-card-body
          b-container.ml-2(fluid="fluid")
            b-row
              b-col
                .font-weight-bold.mt-2.mb-4 現在、ご契約いただいているお客様環境は、下記の通りです。
            b-row
              //- col1 neo
              b-col.pl-0
                b-container(fluid="fluid")
                  //- 未契約
                  //- 契約種別が5となっているデータがない場合
                  template(v-if="neoContractClassNum === 0")
                    b-row
                      b-col.pr-0
                        .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                          .mb-1
                            img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
                          h5.font-weight-bold.ml-1.mb-0.py-2 ご契約環境
                        b-row
                          b-col
                            b-row.border-top.border-bottom.ml-3.mr-1
                              b-col(:class="data_col_class")
                                span ご契約はありません。
                                template(v-if="sales_channel === '0'")
                                  span ご契約は
                                  router-link(:to="{name: 'ApplyPlan'}") こちら
                                  span から
                                template(v-else)
                                  br
                                  | ご契約をされる場合は、販売店にお問い合わせください。
                  //- サービス中
                  template(v-else)
                    b-row(v-for="(row, index) in contract")
                      //- 契約種別が5のデータのみ表示
                      b-col.mb-3(v-if="row.contract_class === '5'")
                        .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                          .mb-1
                            img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
                          h5.font-weight-bold.ml-1.mb-0.py-2 ご契約環境
                        b-row(data-testid="neo_contract")
                          b-col
                            b-row.border-top.ml-3.mr-1(v-if="row.contract_status === VAL_CONTRACT_STATUS.APPLY || (row.contract_status !== VAL_CONTRACT_STATUS.APPLY && row.domain_name)")
                              b-col(:class="data_col_class")
                                .flex-column
                                  template(v-if="row.contract_status !== VAL_CONTRACT_STATUS.APPLY")
                                    a.word-break(:href="'https://' + row.domain_name + '/cgi-bin/dneo/dneo.cgi'", target="_blank", rel="noopener noreferrer" data-testid="neo_url") https://{{row.domain_name}}/cgi-bin/dneo/dneo.cgi
                                    div
                                      b-button.btn-font-size.mt-1(variant="info", :href="'https://' + row.domain_name + '/diskuse.cgi'", target="_blank", rel="noopener noreferrer" data-testid="neo_storage_capacity_url") 使用容量確認
                                  template(v-else)
                                    div ※ 環境構築作業中です。
                            b-row(v-if="sales_channel === '0' && row.billing_period.length >= 1").border-top.ml-3.mr-1
                              b-col(cols="4", :class="overview_title_col_class") ご契約種別
                              b-col(:class="data_col_class" data-testid="neo_billing_period")
                                //- 契約種別の数分表示
                                p(v-for="billing_period in row.billing_period") {{setFlagValue(billing_period, billingPeriodFlgVar)}}
                            //- プラン契約以外の場合は表示しない
                            b-row.border-top.ml-3.mr-1(v-if="plan_list.hasOwnProperty(row.plan_name)")
                              b-col(cols="4", :class="overview_title_col_class") ご契約中のプラン
                              b-col(:class="data_col_class") {{plan_list[row.plan_name]}}
                                b-button.ml-2(
                                  v-if="sales_channel === '0'", pill, variant="outline-primary", size="sm",
                                  :to={name: 'ApplyPlan'}
                                )
                                  span プラン変更
                            b-row(v-if="sales_channel === '0' && row.billing_period.includes('1') === true").border-top.border-bottom.ml-3.mr-1
                              b-col(cols="4", :class="overview_title_col_class") 契約終了日
                              b-col(:class="data_col_class") {{row.billing_end_date}}
                            //b-row.border-top.border-bottom.ml-3.mr-1
                            //  b-col(cols="3", :class="overview_title_col_class") 次回請求予定日
                            //  b-col(:class="data_col_class" data-testid="neo_next_claim")
                            //    //- 次回請求予定日の数分表示
                            //    p(v-for="(next_claim) in row.next_claim") {{next_claim}}
                            b-row(v-else).border-top.ml-3.mr-1
                            b-row
                              b-col.mt-2.mb-3.ml-3
                                b-button.mr-3.btn-font-size.btn-neo-bg-color.btn-outline-light(:to="{name: 'ContractDetails', params: { contract_no: row.contract_no }}") ご契約内容の詳細を確認する
                                b-button.btn-font-size.btn-neo-bg-color.btn-outline-light(:to="{name: 'ContractChanges', params: { contract_no: row.contract_no }}") ご契約内容変更を申し込む
              //- col2 chat
              b-col.pl-0
                b-container(fluid="fluid")
                  //- 未契約
                  //- 契約種別が6となっているデータがない場合
                  template(v-if="chatContractClassNum === 0")
                    b-row
                      b-col
                        .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                          .mb-1
                            img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                          h5.font-weight-bold.ml-1.mb-0.py-2 ご契約環境
                        b-row
                          b-col
                            b-row.border-top.border-bottom.ml-3.mr-1
                              b-col(:class="data_col_class")
                                span ご契約はありません。
                                template(v-if="sales_channel === '0'")
                                  span ご契約は
                                  router-link(:to="{name: 'ApplyPlan'}") こちら
                                  span から
                                template(v-else)
                                  br
                                  | ご契約をされる場合は、販売店にお問い合わせください。
                  //- サービス中
                  template(v-else)
                    b-row(v-for="(row, index) in contract")
                      //- 契約種別が6のデータのみ表示
                      b-col.mb-3(v-if="row.contract_class === '6'")
                        .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                          .mb-1
                            img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                          h5.font-weight-bold.ml-1.mb-0.py-2 ご契約環境
                        b-row(data-testid="chat_contract")
                          b-col
                            b-row.border-top.ml-3.mr-1(v-if="row.contract_status === VAL_CONTRACT_STATUS.APPLY || (row.contract_status !== VAL_CONTRACT_STATUS.APPLY && row.domain_name)")
                              b-col(:class="data_col_class")
                                .flex-column
                                  template(v-if="row.contract_status !== VAL_CONTRACT_STATUS.APPLY")
                                    a.word-break(:href="'https://' + row.domain_name + '/cgi-bin/chatlk/chat.cgi'", target="_blank", rel="noopener noreferrer" data-testid="chatluck_url") https://{{row.domain_name}}/cgi-bin/chatlk/chat.cgi
                                    div
                                      b-button.btn-font-size.mt-1(variant="info", :href="'https://' + row.domain_name + '/diskuse.cgi'", target="_blank", rel="noopener noreferrer" data-testid="chatluck_storage_capacity_url") 使用容量確認
                                  template(v-else)
                                    div ※ 環境構築作業中です。
                            b-row(v-if="sales_channel === '0' && row.billing_period.length >= 1").border-top.ml-3.mr-1
                              b-col(cols="4", :class="overview_title_col_class") ご契約種別
                              b-col(:class="data_col_class" data-testid="chat_billing_period")
                                //- 契約種別の数分表示
                                p(v-for="billing_period in row.billing_period")  {{setFlagValue(billing_period, billingPeriodFlgVar)}}
                            //- ChatLuck単体、ライトプラン、スタンダードプランの場合は表示しない
                            b-row.border-top.ml-3.mr-1(v-if="plan_list.hasOwnProperty(row.plan_name) && (row.plan_name === 'chatplus' || row.plan_name === 'premium')")
                              b-col(cols="4", :class="overview_title_col_class") ご契約中のプラン
                              b-col(:class="data_col_class") {{plan_list[row.plan_name]}}
                                b-button.ml-2(
                                  v-if="sales_channel === '0'", pill, variant="outline-success", size="sm",
                                  :to={name: 'ApplyPlan'}
                                )
                                  span プラン変更
                            b-row(v-if="sales_channel === '0' && row.billing_period.includes('1') === true").border-top.border-bottom.ml-3.mr-1
                              b-col(cols="4", :class="overview_title_col_class") 契約終了日
                              b-col(:class="data_col_class") {{row.billing_end_date}}
                            //b-row.border-top.border-bottom.ml-3.mr-1
                            //  b-col(cols="3", :class="overview_title_col_class") 次回請求予定日
                            //  b-col(:class="data_col_class" data-testid="chat_next_claim")
                            //    //- 次回請求予定日の数分表示
                            //    p(v-for="(next_claim) in row.next_claim")  {{next_claim}}
                            b-row(v-else).border-top.ml-3.mr-1
                            b-row
                              b-col.mt-2.mb-3.ml-3
                                b-button.mr-3.btn-font-size.chat-bg-color.btn-outline-light(:to="{name: 'ContractDetails', params: { contract_no: row.contract_no }}") ご契約内容の詳細を確認する
                                b-button.btn-font-size.chat-bg-color.btn-outline-light(:to="{name: 'ContractChanges', params: { contract_no: row.contract_no }}") ご契約内容変更を申し込む

            //- 障害・メンテナンス情報
            b-row.mt-0
              b-col.pl-0
                b-container(fluid="fluid")
                  b-row
                    b-col
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom.mt-5
                        .mb-1
                          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 障害・メンテナンス情報
                    b-col.pl-0
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom.mt-5
                        .mb-1
                          img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 障害・メンテナンス情報
                  b-row
                    // 最新のdesknet's NEO障害・メンテナンス情報が存在する場合
                    b-col(v-if="this.neoFailure.length > 0")
                      b-row.border-top.ml-3.mr-1(v-for="(row, index) in neoFailure", :key="index")
                        b-col(:class="data_col_class")
                          a.rss-font-size(:href="row.url", target="_blank")
                            | {{row.title}}
                            br
                            | {{row.detail}}
                    // 最新のdesknet's NEO障害・メンテナンス情報が存在しない場合
                    b-col(v-else)
                      b-row.border-top.ml-3.mr-1
                        b-col(:class="data_col_class")
                          a.rss-font-size(href="https://www.desknets.com/cloud/support/mainte/", target="_blank")
                            | 過去の障害・メンテナンス情報
                    // 最新のChatLuck障害・メンテナンス情報が存在する場合
                    b-col.pl-0(v-if="this.chatFailure.length > 0")
                      b-row.border-top.ml-3.mr-1(v-for="(row, index) in chatFailure", :key="index")
                        b-col(:class="data_col_class")
                          a.rss-font-size(:href="row.url", target="_blank")
                            | {{row.title}}
                            br
                            | {{row.detail}}
                    // 最新のChatLuck障害・メンテナンス情報が存在しない場合
                    b-col.pl-0(v-else)
                      b-row.border-top.ml-3.mr-1
                        b-col(:class="data_col_class")
                          a.rss-font-size(href="https://www.chatluck.com/support/cloud/mainte/", target="_blank")
                            | 過去の障害・メンテナンス情報
            //- サポート最新情報
            b-row.mt-5
              b-col.pl-0
                b-container(fluid="fluid")
                  b-row
                    b-col
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                        .mb-1
                          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 サポート最新情報
                    b-col.pl-0
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                        .mb-1
                          img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 サポート最新情報
                  b-row
                    b-col
                      b-row.border-top.ml-3.mr-1(v-for="(row, index) in neoLatestInfo", :key="index")
                        b-col(:class="data_col_class")
                          a(:href="row.url", target="_blank").rss-font-size
                            | {{row.title}}
                            br
                            | {{row.detail}}
                    b-col.pl-0
                      b-row.border-top.ml-3.mr-1(v-for="(row, index) in chatLatestInfo", :key="index")
                        b-col(:class="data_col_class")
                          a(:href="row.url", target="_blank").rss-font-size
                            | {{row.title}}
                            br
                            | {{row.detail}}
            //- 稼働率実績
            b-row.mt-5
              b-col.pl-0
                b-container(fluid="fluid")
                  b-row
                    b-col
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                        .mb-1
                          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 稼働率実績
                    b-col.pl-0
                      .d-flex.justify-content-start.align-items-center.ml-3.mb-2.border-top.border-bottom
                        .mb-1
                          img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                        h5.font-weight-bold.ml-1.mb-0.py-2 稼働率実績
                  b-row
                    b-col
                      h6.ml-3.mr-1 年間稼働率
                      template(v-if="Object.keys(operating_rate_yearly.neo).length !== 0")
                        b-row.border-top.ml-3.mr-1
                          b-col(:class="data_col_class")
                            b-row
                              b-col(cols="5")
                                p.mb-0 {{ formatOperatingRateDate(operating_rate_yearly.neo.start_target_month) }} ~ {{ formatOperatingRateDate(operating_rate_yearly.neo.end_target_month) }}
                              b-col(cols="7")
                                p.mb-0 {{ operating_rate_yearly.neo.operating_rate.toFixed(1) }} %
                      template(v-else)
                        b-row.border-top.ml-3.mr-1(:class="data_col_class")
                          p.mb-0 表示可能な稼働率はございません。
                      b-row.border-bottom.ml-3.mr-1.mb-3
                      h6.ml-3.mr-1 月間稼働率
                      template(v-if="operating_rate_monthly.neo.length !== 0")
                        b-row.border-top.ml-3.mr-1(v-for="(operating_rate, target_date) in operating_rate_monthly.neo", :key="target_date")
                          b-col(:class="data_col_class")
                            b-row
                              b-col(cols="5")
                                p.mb-0 {{ formatOperatingRateDate(target_date) }}
                              b-col(cols="7")
                                p.mb-0 {{ operating_rate.toFixed(1) }} %
                      template(v-else)
                        b-row.border-top.ml-3.mr-1(:class="data_col_class")
                          p.mb-0 表示可能な稼働率はございません。
                      b-row.border-bottom.ml-3.mr-1
                    b-col.pl-0
                      h6.ml-3.mr-1 年間稼働率
                      template(v-if="Object.keys(operating_rate_yearly.chat).length !== 0")
                        b-row.border-top.ml-3.mr-1
                          b-col(:class="data_col_class")
                            b-row
                              b-col(cols="5")
                                p.mb-0 {{ formatOperatingRateDate(operating_rate_yearly.chat.start_target_month) }} ~ {{ formatOperatingRateDate(operating_rate_yearly.chat.end_target_month) }}
                              b-col(cols="7")
                                p.mb-0 {{ operating_rate_yearly.chat.operating_rate.toFixed(1) }} %
                      template(v-else)
                        b-row.border-top.ml-3.mr-1(:class="data_col_class")
                          p.mb-0 表示可能な稼働率はございません。
                      b-row.border-bottom.ml-3.mr-1.mb-3
                      h6.ml-3.mr-1 月間稼働率
                      template(v-if="operating_rate_monthly.chat.length !== 0")
                        b-row.border-top.ml-3.mr-1(v-for="(operating_rate, target_date) in operating_rate_monthly.chat", :key="target_date")
                          b-col(:class="data_col_class")
                            b-row
                              b-col(cols="5")
                                p.mb-0 {{ formatOperatingRateDate(target_date) }}
                              b-col(cols="7")
                                p.mb-0 {{ operating_rate.toFixed(1) }} %
                      template(v-else)
                        b-row.border-top.ml-3.mr-1(:class="data_col_class")
                          p.mb-0 表示可能な稼働率はございません。
                      b-row.border-bottom.ml-3.mr-1
</template>

<script>
import Api from '@/repositories/api'
import { plan_list, cl_contract_details_tbl as lang_cl_contract_details_tbl } from '@/lang/ja_JP'
import Loading from '@/components/Loading'

const topPageRepository = Api.get("topPage")

export default {
  name: "TopPage",
  components: {
    Loading
  },
  props: {
    sales_channel: { type: String, require: true }
  },
  data() {
    return {
      overview_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 overview-title-bg-color",
      overview_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      data_col_class: "py-2 px-2",

      title_col_class: "py-2 px-2 border-right font-weight-bold title-width",
      image_col_class: "y-2 px-2 border-right",
      function_use_rate: {
        fields: [
          { key: "app_suite", label: "AppSuite", sortable: false },
          { key: "schedule", label: "スケジュール", sortable: false },
          { key: "facilities_reservation", label: "設備予約", sortable: false },
          { key: "ToDo", label: "ToDo", sortable: false },
          { key: "information", label: "インフォメーション", sortable: false },
          { key: "pass_around", label: "回覧・レポート", sortable: false },
          { key: "document_management", label: "文書管理", sortable: false },
        ],
        items: [
          {
            app_suite: "35%",
            schedule: "10%",
            facilities_reservation: "10%",
            ToDo: "5%",
            information: "10%",
            pass_around: "7%",
            document_management: "3%"
          }
        ]
      },
      contract: [],
      neoContractClassNum: 0,
      chatContractClassNum: 0,
      nextClaim: [],
      neoFailure: [],
      chatFailure: [],
      neoLatestInfo: [],
      chatLatestInfo: [],
      billingPeriodFlgVar: lang_cl_contract_details_tbl.bill_period,

      // プラン名
      plan_list: plan_list,

      operating_rate_monthly: {
        neo: [],
        chat: []
      },

      operating_rate_yearly: {
        neo: {},
        chat: {}
      },

      // 読み込み中フラグ
      isLoading: false
    }
  },
  mounted () {
    // エラーメッセージを設定する
    if (this.$route.query.alert) {
      let sErrorMessage = ''
      switch (this.$route.query.alert) {
        case 1:
          sErrorMessage = 'desknet\'s NEOをご契約していないため、desknet\'s NEOの契約変更を行う事ができません。'
          break
        case 2:
          sErrorMessage = 'ChatLuckをご契約していないため、ChatLuckの契約変更を行う事ができません。'
          break
        case 3:
          sErrorMessage = 'desknet\'s NEOまたはChatLuckのいずれかをご契約していないため、ユーザー数の変更を行う事ができません。'
          break
        case 4:
          sErrorMessage = 'ChatLuckが環境構築中の場合は、desknet\'s NEOの契約申込を行う事ができません。'
          break
        case 5:
          sErrorMessage = 'desknet\'s NEOが環境構築中の場合は、ChatLuckの契約申込を行う事ができません。'
          break
        case 6:
          sErrorMessage = '既にdesknet\'s NEOをご契約されているため、desknet\'s NEOの契約申込を行う事ができません。'
          break
        case 7:
          sErrorMessage = '既にChatLuckをご契約されているため、ChatLuckの契約申込を行う事ができません。'
          break
      }

      // アラートを表示する
      this.$bvToast.toast(sErrorMessage, {
        noAutoHide: true,
        toaster: 'b-toaster-top-full',
        headerClass: 'text-center',
        toastClass: 'text-center',
        variant: "danger",
        solid: true,
      })
    }
  },
  created () {
    // 読み込み中
    this.isLoading = true;

      topPageRepository.get()
      .then((response) => {
        // 契約情報を保存
        const arContract = response.data.data

        // 契約情報のキー（契約番号）を取得
        for (let key in arContract) {
          // 契約番号のみを取得
          if (isNaN(key) === false) {
            // 配列に追加
            this.contract.push(arContract[key])
          }
        }

        // 契約情報の契約番号を取得
        for (let index in this.contract) {
          // // 次回請求予定日を「年月日」表記に整形する
          // for (let num in this.contract[index].next_claim) {
          //   this.contract[index].next_claim[num] = this.contract[index].next_claim[num].replace(/(\d+)-(\d+)-(\d+)/g, '$1年$2月$3日');
          // }

          // 契約種別が「5」のデータ数を取得
          if (this.contract[index].contract_class === '5') {
            this.neoContractClassNum++

            // ドメイン名をチェックし、値がnullまたは空文字の場合は次のループへ
            if (this.contract[index].domain_name === null || this.contract[index].domain_name === '') continue

            // NEOの月間顧客稼働率の一覧データを保存
            this.operating_rate_monthly.neo = this.contract[index].operating_rate_monthly

            // NEOの年間顧客稼働率のデータを保存
            this.operating_rate_yearly.neo = this.contract[index].operating_rate_yearly

            // ローカルストレージにdesknet's NEOのドメイン名を保存する
            localStorage.setItem('neo_domain_name', this.contract[index].domain_name)
          }
          // 契約種別が「6」のデータ数を取得
          else if (this.contract[index].contract_class === '6') {
            this.chatContractClassNum++

            // ドメイン名をチェックし、値がnullまたは空文字の場合は次のループへ
            if (this.contract[index].domain_name === null || this.contract[index].domain_name === '') continue

            // ChatLuckの月間顧客稼働率の一覧データを保存
            this.operating_rate_monthly.chat = this.contract[index].operating_rate_monthly

            // ChatLuckの年間顧客稼働率のデータを保存
            this.operating_rate_yearly.chat = this.contract[index].operating_rate_yearly

            // ローカルストレージにChatLuckのドメイン名を保存する
            localStorage.setItem('chat_domain_name', this.contract[index].domain_name)
          }
        }

        // NEOの障害・メンテナンス情報の一覧データを保存
        this.neoFailure = response.data.data.failure['neo']
        this.formatRSS(this.neoFailure)

        // ChatLuckの障害・メンテナンス情報の一覧データを保存
        this.chatFailure = response.data.data.failure['chat']
        this.formatRSS(this.chatFailure)

        // NEOのサポート最新情報の一覧データを保存
        this.neoLatestInfo = response.data.data.latest_info['neo']
        this.formatRSS(this.neoLatestInfo)

        // ChatLuckのサポート最新情報の一覧データを保存
        this.chatLatestInfo = response.data.data.latest_info['chat']
        this.formatRSS(this.chatLatestInfo)
      })
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, '画面表示処理', "Support")

        // エラーメッセージをセットする
        this.setErrors(error)
      })
      .finally(() => [
        // 読み込み完了
        this.isLoading = false
      ])
  },
  methods: {
    formatDate (value) {
      // 記事タイトルの取得
      let sTitle = value.title;

      // 記事タイトルに【  】部分が含まれている場合
      if(sTitle.includes('【')) {
        // 記事タイトルの日付部分を取得する
        let sDate = sTitle.substr(0, sTitle.indexOf('【'));
        // 記事タイトルの【  】部分を取得する
        let sCategory = sTitle.substr(sTitle.indexOf('【'));
        // 記事のタイトルの日付を「年月日」表記に整形する
        sDate = sDate.replace(/(\d+)-(\d+)-(\d+)/g, '$1/$2/$3');
        // 記事情報に整形した日付と【  】部分を結合した文字列を返す
        return sDate + sCategory
      }
      else {
        let sDate = sTitle.replace(/(\d+)-(\d+)-(\d+)/g, '$1/$2/$3');
        // 記事情報に整形した日付を文字列で返す
        return sDate;
      }
    },
    formatRSS (arRSS) {
      arRSS.forEach((value, index) => {
        //RSS取得情報一覧データのタイトルを整形後のものに更新
        arRSS[index].title = this.formatDate(value)
      })
    },
    // 顧客稼働率の対象年月を表示用に整形する
    formatOperatingRateDate (sDate) {
      // 「YYYY年MM月」形式で出力する
      return sDate.substr(0,4) + '年' + sDate.substr(4).replace(/^0+/, '') + '月';
    }
  }
}
</script>

<style scoped>
.white-space {
  width: 320px;
  white-space: pre-wrap;
}
.word-break {
  word-break: break-word;
}
.title-width {
  max-width: 325px;
}
.btn-font-size {
  font-size: 14px;
}
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.circle-image-size {
  width: 367px;
  height: 271px;
}
.overview-title-bg-color {
  background-color: #f5f5f5;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.table-title-col-width {
  max-width: 221px;
}
.rss-font-size {
  font-size: 14px;
}
/*.body-width {*/
/*  max-width: 923px;*/
/*}*/
</style>